// Copyright (C) 2021 Bystronic Laser AG

export enum MachineType {
  Undefined = 0,
  Cut = 1,
  Bend = 2,
  FactoryOverview = 3,
  Tube = 4,
}
